<template>
    <div>
        <div class="bor100">
            <div class="home_menu">
                <div class="home_logo">
                    <a href="#/"><img src="../assets/logo.png"></a>
                    <em>{{$t('m.OrderCenter')}}</em>
                </div>
                <div class="home_hover">
                    <span v-if='p_data.loginState==1'>
                        <em >{{p_data.userName}}</em>
                        <div class="hover_bj">
                            <ol style="border-bottom:1px dashed #a8a8a8;">{{$t('m.Order_management')}}</ol>
                            <ol @click='storageLocal'>{{$t('m.quit')}}</ol>
                        </div>
                    </span>
                    <span class="login" v-if='p_data.loginState==0'>
                        <em @click='isshowLogin=true'>{{$t('m.log_in')}}</em>
                        <em @click='isshowRegist=true'>{{$t('m.register')}}</em>
                    </span>
                    <b @click="$toggle_lang"></b>
                </div>
            </div>
        </div>
        <div class="add_center">
            <div class="add_left">
                <ul>
                    <li v-for='cla in classList' :class="{'on':cla.id==selClass}" @click='toggle_menu(cla)'>{{cla.name}}</li>
                </ul>
            </div>
            <div class="add_right">
                <ul class='add_right_list'>
                    <li v-for='order in orderList'>
                        <div class="add_tt">
                            <span>{{$t('m.order_number')}}：{{order.orderNum}} &nbsp;&nbsp;&nbsp;{{order.createTime}}</span>
                            <ol class="foo" @click='pay(order.orderId)'>{{$t('m.Pay')}}</ol>
                            <ol>{{order.orderStatusName}}</ol>
                            <div class="clear"></div>
                        </div>
                        
                        <div class="add_2">
                            <img src="../assets/eimg.gif">
                            <div class="rg_n">
                                <span>{{order.brandName}}-{{order.modelName}}-{{order.colorName}}</span>
                                <!-- <ol class="a1">黑屏</ol>
                                <ol class="a2">电源不耐用</ol> -->
                                <ol v-for='(quest,index) in order.questionName' class="a3">{{quest}}</ol>
                                <div class="clear"></div>
                                <em>{{$t('m.address')}}：{{order.storeAddress}}</em>
                            </div>
                            <div class="rg_r">
                                <span>{{$t('m.Appointment_to_shop_time')}}：{{order.appointment}} {{order.startTime}}<br />
                                {{$t('m.Paid')}}：<strong>${{order.expectedPrice||'0'}}</strong></span>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </li>
                    <alan-zwdd :isShowZwdd='orderList.length==0'></alan-zwdd>
                </ul>
                <div v-if='orderList.length' class='page'>
                    <Page :total='100' :transfer='true' show-elevator on-change='changePage'/>
                </div>
            </div>
            <div class="clear"></div>
        </div>

        <alan-regist :isshowRegist='isshowRegist' :close='()=>{isshowRegist = false}' :regi_succ='()=>{isshowRegist = false}'></alan-regist>
        <alan-login :isshowLogin='isshowLogin' :close='()=>{isshowLogin = false}' :login_succ='()=>{isshowLogin = false}'></alan-login>
    </div>
</template>
<script>
import {Init,Req,toggle_lang} from '../common/common.js'
export default {
    data(){
        return {
            //             this.$t('m.order_number')
            classList:[
                {id:'0',name:this.$t('m.All'),type:''},
                {id:'1',name:this.$t('m.To_be_paid'),type:'0'},
                {id:'2',name:this.$t('m.Already_reserved'),type:'1'},
                {id:'3',name:this.$t('m.in_maintenance'),type:'2'},
                {id:'4',name:this.$t('m.Repair_completed'),type:'3'},
                {id:'5',name:this.$t('m.Cancelled'),type:'4'},
                {id:'6',name:this.$t('m.Order_completed'),type:'5'},
            ],
            selClass:'0',
            userName:'',
            orderList:[],
            isshowRegist:false,
            isshowLogin:false,
            p_data:this.$store.state,

        }
    },
    methods:{
        //获取订单列表
        getOrderList(type){
            const vm = this;
            const resData = Init('getOrderList');
            resData.customerId = localStorage.customerId;
            resData.pageNum = "2";
            resData.orderStatus = type;
            Req(resData,res=>{
                if(res.ret=='1'){
                    vm.orderList = res.rows;
                    vm.orderList.map(data=>{
                        data.questionName = data.questionName.split(',');
                        return data;
                    })
                }
            })
        },
        pay(orderId){
            const vm = this;
            const resData = Init('submitPayMoney');
            resData.orderId = orderId;
            resData.customerId = localStorage.customerId;
            Req(resData,res=>{
                if(res.ret=='1'){
                    vm.$Message.success(vm.$t('m.payment_successful'));
                }else{
                    vm.$Message.error(res.msg);
                }
            })
        },
        toggle_menu(obj){
            this.selClass = obj.id;
            this.getOrderList(obj.type)
        },
        changePage(pageNum){
            console.log(pageNum);
        }
    },
    created(){
        const vm = this;
        if(localStorage['userName']){vm.userName = localStorage['userName'];}
        if(localStorage['RFIDuuid']){vm.userId = localStorage['RFIDuuid']}
        vm.getOrderList()
    }
}
</script>
<style scoped>
    .page{text-align: center;}
</style>